(function () {
  const SHOW_AFTER_PX = 120;

  function getScrollTop() {
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function initScrollToTop(button) {
    if (!button || button.dataset.tcgScrollTopInit === 'true') return;
    button.dataset.tcgScrollTopInit = 'true';

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function updateVisibility() {
      const show = getScrollTop() > SHOW_AFTER_PX;
      button.classList.toggle('is-visible', show);
      button.setAttribute('aria-hidden', show ? 'false' : 'true');
      button.tabIndex = show ? 0 : -1;
    }

    function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }

    button.addEventListener('click', scrollToTop);
    window.addEventListener('scroll', updateVisibility, { passive: true });
    document.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(updateVisibility);
      ro.observe(document.body);
      ro.observe(document.documentElement);
    }

    updateVisibility();
    window.setTimeout(updateVisibility, 400);
    window.setTimeout(updateVisibility, 1200);
  }

  function boot() {
    document.querySelectorAll('[data-tcg-scroll-to-top]').forEach(initScrollToTop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
